export enum YOrNDesc {
  Y = 'Yes',
  N = 'No',
}
